import classNames from "classnames";
import { IGoalDatapointLatest } from "motw_core/DTOs/goaldatapointlatest";
import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import * as styles from "source/app/presentation/MainPanel/Goals/GoalCards/GoalCards.css";
import { maxGoodDaysLeft } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/GoalCardsConstants";
import { GoalCardContents } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/Contents/GoalCardContents";
import GetGoalColor from "source/app/presentation/MainPanel/Goals/GoalHelpers/GoalHelpers";
import { Style, StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { webkitFilterGlitchFix } from "source/app/presentation/Shared/Styles/SharedStyles";
import { MathUtils } from "source/app/services/Math/MathUtils";
import { ETexture } from "source/app/services/UI/Background/Texture/ETexture";
import { Texture } from "source/app/services/UI/Background/Texture/Texture";
import { IGoalStreakInfoDTO } from "../../../../../../../../motw_core/DTOs/GoalStreakInfo/IGoalStreakInfoDTO";
import { GetGameIdentityForGoal } from "../../../GameIdentities/Helpers/GetGameIdentityForGoal";

export function ShowGoalCard({
    goal,
    goalDatapointLatest,
    isLoggedToday,
    isGameIdentityGoal,
    goalStreakInfo,
    randomGoalCardId,
}: {
    goal: IGoal;
    goalDatapointLatest?: IGoalDatapointLatest;
    isLoggedToday: boolean;
    isGameIdentityGoal: boolean;
    goalStreakInfo: IGoalStreakInfoDTO;
    randomGoalCardId: number;
}) {
    const marginRight = IsMobileDevice()
        ? `-4px`
        : `${MathUtils.RandomNumberBetween(-1, 2)}px`;

    const upgradeGoalCardStyleClass = StyleClass(`upgradableGoalCard`, {
        ...new Texture({
            image: ETexture.diagmonds,
            backgroundColor: { h: 50, s: 89, l: 76, a: 1 },
        }).combinedCSS,
        backgroundSize: `contain`,
        boxShadow: `0px 0px 25px gold`,
    });

    const randomGoalCardStyleClass = StyleClass(`randomGoalCard`, {
        ...new Texture({
            image: ETexture.diagmonds,
            backgroundColor: { h: 50, s: 69, l: 48, a: 0.45 },
        }).combinedCSS,
        backgroundSize: `contain`,
        boxShadow: `0px 0px 25px yellowgreen`,
    });

    const GetOpacity = () => {
        if (!goal.energyrank) {
            return 0.5;
        }

        if (goal.isarchived) {
            return 0.5;
        }

        return 1.0;
    };

    const GetTooltipText = (goal: IGoal) => {
        const goalTypeText = goal.isarchived
            ? ` (archived)`
            : !goal.istracking
            ? ` (untracked)`
            : ``;

        const goalNotesText = goal.notes !== null ? ` > ${goal.notes}` : "";
        const tooltipText = `${goal.name}${goalTypeText}${goalNotesText}`;
        return tooltipText;
    };

    return (
        <span
            id={`scrollTarget_showGoalCard_${goal.id}`}
            data-tip={GetTooltipText(goal)}
            {...Style(
                `goalCard_${goal.isupper}_${goal.isarchived}_${marginRight}_${goal.energyrank}_${isLoggedToday}`,
                {
                    color: GetGoalColor(goal.isupper),
                    opacity: GetOpacity(),
                    marginRight,
                    borderRadius: `5px`,
                    backgroundColor: isLoggedToday
                        ? `hsl(86deg 73% 37% / 56%)`
                        : `transparent`,
                    ...webkitFilterGlitchFix,
                }
            )}
            className={classNames("goalCard", [styles.goalCard], {
                [randomGoalCardStyleClass]: goal.id === randomGoalCardId,
                [styles.archivedGoal]: goal.isarchived,
                [upgradeGoalCardStyleClass]:
                    Math.floor(goal.daysleft) > maxGoodDaysLeft &&
                    goal.istracking,
            })}
        >
            <GoalCardContents
                goal={goal}
                isLoggedToday={isLoggedToday}
                isGameIdentityGoal={isGameIdentityGoal}
                goalDatapointLatest={goalDatapointLatest}
                goalStreakInfo={goalStreakInfo}
            />
        </span>
    );
}
